
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/private-tours",
      function () {
        return require("private-next-pages/private-tours.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/private-tours"])
      });
    }
  